(() => {
  if (window.__cloudSearchMobileScrollFixInit) return;
  window.__cloudSearchMobileScrollFixInit = true;

  const mq = window.matchMedia('(max-width: 749px)');
  let savedY = 0;

  const isMobile = () => mq.matches;

  const rememberScroll = () => {
    if (!isMobile()) return;
    savedY = window.scrollY;
  };

  const preserveScroll = () => {
    if (!isMobile() || !savedY) return;
    if (window.scrollY === savedY) return;

    window.scrollTo(0, savedY);
    requestAnimationFrame(() => window.scrollTo(0, savedY));
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!isMobile()) return;
      if (event.target.closest('.header__search-bar, .header__icon--search, .header__search summary')) {
        rememberScroll();
      }
    },
    true
  );

  new MutationObserver(() => {
    if (!isMobile()) return;

    if (document.documentElement.classList.contains('cloud-search-mobile-open')) {
      preserveScroll();
      return;
    }

    savedY = window.scrollY;
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
})();
